<ng-template #titleArea>
	<span fxShow [fxHide.gt-sm]="!showMenuDesktop">
		<button mat-button (click)="toggle()" class="sidenav-toggle" *appUserRole="{ customRole: MDM_ADMINS }">
			<mat-icon>menu</mat-icon>
		</button>
	</span>

	<a routerLink="/" fxLayout="row" fxLayoutAlign="center center" class="logo-focusable">
		<img class="logo" src="assets/images/hero/logo.png" alt="Portal logo" />
		<span class="f-lg-30 ag-hero-title">Device Enrollment</span>
	</a>
</ng-template>

<ng-template #userInfo>
	<button mat-icon-button [matMenuTriggerFor]="userInfoMenu" #userInfoMenuTrigger="matMenuTrigger"
		class="white-icon centre-item">
		<input type="image" [src]="getProfilePhoto()" (error)="onImageError($event)" class="profile-photo" alt="User profile photo" />
	</button>

	<div class="top-menu-item">
		<mat-menu #userInfoMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="app-dropdown account">
			<span (mouseleave)="userInfoMenuTrigger.closeMenu()">
				<button mat-menu-item class="user-info">
					<span>{{ user?.employeeId }} ({{ user?.country }}) </span>
				</button>
				<div class="divider"></div>
				<button mat-menu-item (click)="(null)" (keyup.enter)="(null)">
					<mat-icon class="mat-icon-sm icon-color">help</mat-icon>
					<span>Help</span>
				</button>
				<div class="divider" fxHide.gt-sm></div>
				<a mat-menu-item (click)="logout()" (keyup.enter)="logout()" fxHide.gt-sm>
					<mat-icon class="mat-icon-sm icon-color">power_settings_new</mat-icon>
					<span>Sign Out</span>
				</a>
			</span>
		</mat-menu>
	</div>

	<div class="mr-1" fxHide.xs>{{ user?.displayName }}</div>
	<button fxHide.xs mat-raised-button color="primary" (click)="logout()" class="logout-btn">
		Logout
	</button>
</ng-template>

<mat-toolbar-row fxLayoutAlign="space-between center" class="ag-hero top-toolbar theme-container admin-toolbar">
	<div *ngIf="showMenuDesktop && !isMobile; else titleArea" fxLayout="row" fxLayoutAlign="center center">
		<ng-container *ngTemplateOutlet="titleArea"></ng-container>
	</div>

	<div *ngIf="showMenuDesktop && !isMobile; else userInfo" fxLayout="row" fxLayoutAlign="end center">
		<ng-container *ngTemplateOutlet="userInfo"></ng-container>
	</div>
</mat-toolbar-row>